import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e6c1434")

_pushScopeId("data-v-1e6c1434")
const _hoisted_1 = { class: "shell padding30px" }
const _hoisted_2 = { class: "detail-label detail-label-title" }
const _hoisted_3 = { class: "detail-label" }
const _hoisted_4 = { class: "detail-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_list = _resolveComponent("list")
  const _component_billing_information = _resolveComponent("billing-information")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.infoItem, (item) => {
      return (_openBlock(), _createBlock("div", {
        key: item.name
      }, [
        _createVNode("label", _hoisted_2, _toDisplayString(item.label) + ":", 1),
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.infoDetail[item.name] ? _ctx.infoDetail[item.name] : '--'), 1)
      ]))
    }), 128)),
    _createVNode("b", _hoisted_4, _toDisplayString(_ctx.$wordList.PmApp), 1),
    _createVNode(_component_list, {
      headers: _ctx.headers,
      "show-check": false,
      action: false,
      "list-data": _ctx.infoDetail.PmAppInfo,
      update: _ctx.updateList
    }, {
      ActionSlot: _withId((data) => [
        _createVNode(_component_cus_button, {
          onClick: ($event: any) => (_ctx.getBillingInfo(data.scope.ID))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.OrderBillingInformation), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["headers", "list-data", "update"]),
    (_ctx.isShowBillInfo)
      ? (_openBlock(), _createBlock(_component_billing_information, {
          key: 0,
          "user-id": _ctx.userId,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowBillInfo=false))
        }, null, 8, ["user-id"]))
      : _createCommentVNode("", true)
  ]))
})